export default "__VITE_ASSET__SPTFa08Q0Hys_vMs1FbGpg__";